/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import ObjectUtil from '@leverege/object-util'
import StringUtil from '@leverege/string-util'
import { getTagsForAttributes, TreeOrganizer, Util } from '@leverege/api-attributes'
import { Button, Flex, ToggleButton } from '@leverege/ui-elements'
import Bluestore from '@leverege/data-store'
import { Grid, Col } from 'react-bootstrap'
import { Tags, ValueCardGroup, Screen } from '~/views'
import { DeviceActions, BreadcrumbActions, NotifyActions } from '~/actions'
import SimAttributeView from './SimAttributeView'
import SimAttributeEditor from './SimAttributeEditor'
import SimCollectionView from './SimCollectionView'
import ScenarioSelector from './ScenarioSelector'
import { BlueprintActions } from '../../actions'
import AttributeTreeView from './AttributeTreeView'
import RelationshipAttributeView from './RelationshipAttributeView'
import JSONView from './JSONView'

import style from './style.css'

class SimControlScreen extends React.Component {
  
  static contextTypes = { 
    api : PropTypes.object.isRequired,
  };
  
  constructor( props ) {
    super( props );
    this.datastore = null
    // this.simStore = null
    this.datastoreCallback = ( snapshot ) => { this.setState( { deviceData : snapshot.val() } ) }
    this.simStoreCallback = ( snapshot ) => { this.setState( { simStatus : snapshot.val() } ) }
    this.state = { tags : [], deviceData : {}, updaters : { }, showDialog : false, mode : 'normal' }
    this.onUpdaterChanged = this.onUpdaterChanged.bind( this )

    this.treeOrganizer = new TreeOrganizer()
  }

  componentDidMount() {
    const { match, dispatch } = this.props
    dispatch( BlueprintActions.listBlueprints( match.params.projectId ) )
    const { mode } = this.state
    const s = new URLSearchParams( window.location.search )
    if ( s.has( 'mode' ) && mode !== s.get( 'mode' ) ) {
      this.setState( { mode : s.get( 'mode' ) } )
    }
    dispatch( DeviceActions.getDeviceBlueprint( match.params.systemId, match.params.deviceId ) );
  }

  componentWillReceiveProps( nextProps ) {
    const { api } = this.context
    const { dispatch } = this.props
    const oldDevice = this.props && this.props.deviceBlueprint && this.props.deviceBlueprint.device
    const oldId = oldDevice && oldDevice.id
    const device = nextProps && nextProps.deviceBlueprint && nextProps.deviceBlueprint.device
    const newId = device && device.id

    const isSim = isSimulated( device )
    if ( this.props.match.params.deviceId !== nextProps.match.params.deviceId ) {
      const { systemId, deviceId } = nextProps.match.params
      dispatch( DeviceActions.getDeviceBlueprint( systemId, deviceId ) )
      return
    }
    if ( ( this.datastore == null || ( oldId !== newId && newId != null ) ) && device && device.accessToken ) {
      if ( this.datastore != null ) {
        this.datastore.service( 'simulator' ).off( '', this.simStoreCallback )
      }
      this.datastore = Bluestore.createDatabase( device.accessToken )
      this.datastore.signIn( device.accessToken.jwt ).then( () => {
        if ( this.datastore == null ) {
          return
        }
        this.datastore.on( '', this.datastoreCallback )
        if ( isSim ) {
          this.datastore.service( 'simulator' ).on( '', this.simStoreCallback )
        }
      } ).catch( ( ex ) => {
        console.log( 'Error signing into datastore', ex )
      } )
    }
    
    // get the updaters for the simulated device. TODO: add option for server to give this with initial query
    if ( isSim ) {
      api.getDeviceUpdaters( device ).then( ( data ) => {
        const u = {}
        if ( typeof data === 'string' ) { data = JSON.parse( data ) }
        if ( data ) { 
          for ( let n = 0; n < data.length; n++ ) { 
            u[data[n].path] = data[n]
          }
        }
        this.setState( { updaters : u } )
      } )
    }

    const sys = nextProps.deviceBlueprint && nextProps.deviceBlueprint.system
    const blueprint = nextProps.deviceBlueprint && nextProps.deviceBlueprint.blueprint
    
    if ( sys && device && blueprint ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${sys.projectId}/system` }, 
          { name : sys.name, link : `/project/${sys.projectId}/system/${sys.id}/device` },
          { name : blueprint.name, link : `/project/${sys.projectId}/system/${sys.id}/blueprint/${blueprint.id}/device` },
          { name : device.name } ] ) )
    } else if ( sys && device ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${sys.projectId}/system` }, 
          { name : sys.name, link : `/project/${sys.projectId}/system/${sys.id}/device` },
          { name : device.name } ] ) )
    }
  }

  componentWillUnmount() {
    if ( this.datastore ) {
      this.datastore.off( '', this.datastoreCallback )
      if ( this.simStoreCallback ) {
        this.datastore.service( 'simulator' ).off( '', this.simStoreCallback )
      }
      this.datastore = null
    }
  }

  onSetMode = ( e ) => {
    this.setState( { mode : e.data } )
    const loc = window.location
    window.history.replaceState( {}, '', `${loc.origin}${loc.pathname}?mode=${e.data}` )
  }

  onUpdaterChanged( evt ) {
    const { updater, attribute } = evt
    const { api } = this.context
    const device = this.props.deviceBlueprint && this.props.deviceBlueprint.device
    if ( device ) {
      api.setDeviceUpdater( device, attribute.path, updater ).then( ( data ) => {
        const clone = ObjectUtil.copy( this.state.updaters )
        clone[attribute.path].updater = updater
        this.setState( { updaters : clone } )
      } ).catch( ( ex ) => {
        console.log( 'error sending updater', ex )
      } )
    }
  }

  onSetValue = ( evt ) => {

    const { attribute, value, path } = evt
    const { dispatch } = this.props
    const { api } = this.context
    const device = this.props.deviceBlueprint && this.props.deviceBlueprint.device
    if ( device ) {
      if ( attribute == null ) {
        api.setValue( device, path, value )
          .catch( ( ex ) => {
            dispatch( NotifyActions.requestError( 'Set Value Failed', ex ) )
          } )
      } else {
        api.setValue( device, path || attribute.path, value )
          .catch( ( ex ) => {
            dispatch( NotifyActions.requestError( 'Set Value Failed', ex ) )
          } )
      }
    }
  }

  onShowScenarioPicker = ( evt ) => {
    this.setState( { showDialog : true } )
  }

  onScenarioSelected = ( scenario, loop ) => {
    const { api } = this.context
    const { dispatch } = this.props
    const device = this.props.deviceBlueprint && this.props.deviceBlueprint.device
    if ( device == null ) {
      return
    }

    this.setState( { showDialog : false } )
    api.playScenario( device.systemId, device.id, scenario.id, { loop } )
      .then( ( ) => {
        dispatch( NotifyActions.success( 'Scenario', `Playing ${scenario.name}` ) )
      } )
      .catch( ( ex ) => { 
        dispatch( NotifyActions.requestError( `Oops! Failed to play ${scenario.name}`, ex ) )
      } )
  }

  onStop = ( ) => {
    const { api } = this.context
    const device = this.props.deviceBlueprint && this.props.deviceBlueprint.device
    if ( device != null ) {
      api.stopScenario( device.systemId, device.id )
    }
  }

  render() {

    const device = this.props.deviceBlueprint && this.props.deviceBlueprint.device;
    const blueprint = this.props.deviceBlueprint && this.props.deviceBlueprint.blueprint;
    const attrs = blueprint && blueprint.attributes;

    if ( device == null || blueprint == null ) {
      return <div style={{ padding : '24px' }}>Loading</div>
    }

    const { tags, deviceData, mode } = this.state
    const currentTags = getTagsForAttributes( blueprint.attributes, true );
    const isSim = isSimulated( device )

    const editors = []
    this.treeOrganizer.tags = tags
    this.treeOrganizer.attributes = attrs
    const tree = this.treeOrganizer.getTree( )
    
    editors.push( (
      mode === 'normal' ? (
        <AttributeTreeView 
          key="root" 
          device={device} 
          deviceData={deviceData} 
          controller={this}
          onSetValue={this.onSetValue}
          onSetUpdater={this.onUpdaterChanged}
          tags={tags}
          blueprint={blueprint} />
      ) : (
        <RelationshipAttributeView
          key="root"
          device={device}
          deviceData={deviceData}
          controller={this}
          onSetValue={this.onSetValue}
          onSetUpdater={this.onUpdaterChanged}
          tags={tags}
          blueprint={blueprint} />
      )
    ) )

    // const org = OrganizeAttrs.organizeAttrs( sAttrs )
    
    if ( editors.length === 0 ) {
      editors.push( <div key="attr-no'">No matching attributes</div> );
    }
    const { simStatus } = this.state
    const playing = simStatus && simStatus.status && simStatus.status.detail && simStatus.status.detail.scenario
    return (
      <Screen>
        <Screen.Header className={style.header}>
          { mode !== 'json' && (
            <Tags
              tags={tags}
              placeholder="Search..."
              autofocus={false}
              suggestions={currentTags || []}
              tagAdded={( tag, arr ) => { this.setState( { tags : arr } ); }}
              tagRemoved={( tag, arr ) => { this.setState( { tags : arr } ); }} />
          ) }
          { mode === 'json' && <div style={{ flex : '1 0 0' }} /> }
          <Flex direction="row" style={{ paddingRight : '32px', gap : '8px' }}>
            <ToggleButton
              variant="iconSmall"
              icon="fa fa-sliders fa-fw"
              eventData="normal"
              value={mode === 'normal'}
              onChange={this.onSetMode}/>
            <ToggleButton
              variant="iconSmall"
              icon="fa fa-sitemap fa-fw"
              eventData="relationships"
              value={mode === 'relationships'}
              onChange={this.onSetMode}/>
            <ToggleButton
              variant="iconSmall"
              icon="fa fa-code fa-fw"
              eventData="json"
              value={mode === 'json'}
              onChange={this.onSetMode}/>          
          </Flex>
          { isSim ?
            (
              <Button
                className={style.playScenarioButton} 
                // bsStyle="primary"
                onClick={this.onShowScenarioPicker}>
                <i className="fa fa-play" />
              </Button>
            ) : (
              <div className={style.realMsg}>Actual Device</div> 
            ) }
        </Screen.Header>
        <Screen.Content>
          { ( mode === 'normal' || mode === 'relationships' ) && (
            <Grid fluid>
              {editors}
            </Grid> 
          ) }
          {/* { mode === 'json' && <pre>{JSON.stringify( deviceData, null, 2 )}</pre>} */}
          { mode === 'json' && ( <JSONView node={blueprint} device={device} deviceData={deviceData} controller={this} /> )}
        </Screen.Content>
        {
          playing ? (
            <Screen.Footer className={style.footer}> 
              <span className={style.scenarioTime}>{labelFor( playing.time )}</span>
              <span className={style.scenarioName}>{playing.name}</span>
              <Button
                className={style.stopButton} 
                // bsStyle="warning"
                onClick={this.onStop}>
                <i className="fa fa-stop" />
              </Button> 
            </Screen.Footer>
          ) : null

        } 
        { isSim ?
          (
            <ScenarioSelector 
              projectId={this.props.match.params.projectId} 
              blueprintId={blueprint.id} 
              show={this.state.showDialog} 
              flagName="Loop"
              showFlag
              onHide={() => { this.setState( { showDialog : false } ) }} 
              onItemSelected={this.onScenarioSelected}
              message="Select a scenario to play" />
          ) : null }
      </Screen>
    );
  }

  createEditors( device, node, deviceData, cxt = {} ) {
    // node = consolidateEditors( node );
    const editors = [];
    if ( Util.isPathValid( node.pathname ) && Util.isLeafCollection( node.pathname ) ) {
      this.createCollectionEditor( device, node, editors, deviceData, cxt );
    } else if ( node.type === 'group' ) {
      this.createGroupEditor( device, node, editors, deviceData, true, cxt );
    } else {
      this.createAttributeViewer( device, node, editors, deviceData, cxt );
    }

    return <Col xs={12} sm={6} md={6} lg={6} key={`tree-${node.pathname}`} style={{ display : 'inline-block' }}>{editors}</Col>
  }

  createCollectionEditor( device, node, pEditors, deviceData, cxt, opts ) {

    const renderEditors = ( node, cxt, opts ) => {
      let acc = Util.getCollectionHandler( { path : node.pathname } )
      if ( !acc ) {
        return null
      }
      acc = acc( deviceData, cxt )
      const list = acc.keys( deviceData )
      const editors = []
      if ( node.type === 'group' ) {
        list.forEach( ( { path, context } ) => {
          this.createGroupEditor(
            device,
            { ...node, pathname : path, name : path.split( '/' ).slice( -1 )[0] },
            editors,
            deviceData, 
            false,
            { ...cxt, ...context },
            opts,
            true
          )
        } )
      } else {
        list.forEach( ( { path, context } ) => {
          this.createAttributeViewer(
            device,
            { ...node, pathname : path, name : path.split( '/' ).slice( -1 )[0] },
            editors,
            deviceData,
            { ...cxt, ...context },
            opts,
            true
          )
        } )
      }
      return editors
    }

    const getNewEditor = ( newNode, cxt, opts ) => {
      // const attr = newNode.attribute
      // const path = ( attr && attr.path ) || newNode.pathname
      // const ids = Util.getPathIds( path )
      // const colls = Util.getPathCollections( path )
      // const resPath = Util.getResolvedPath( path, cxt, ids, colls )

      const newEditors = []
      if ( newNode.type === 'group' ) {
        this.createGroupEditor(
          device,
          newNode,
          newEditors,
          opts && opts.deviceData,
          false,
          cxt,
          opts
        )
      } else {
        this.createAttributeEditor(
          device,
          newNode,
          newEditors,
          opts && opts.deviceData,
          cxt,
          { ...opts, liveMsg : '', inputProps : { changeOnReturn : false, alwaysFireOnReturn : false, changeOnBlur : true } }
        )
      }
      return newEditors
    }

    pEditors.push(
      <SimCollectionView
        deviceData={deviceData}
        key={node.pathname}
        cxt={cxt}
        renderEditors={renderEditors}
        getNewEditor={getNewEditor}
        onSetValue={( opts && opts.onSetValue ) || this.onSetValue}
        node={node} />
    )
    
  }

  createGroupEditor( device, node, pEditors, deviceData, isRoot = false, cxt = {}, opts = {}, showDelete = false ) {
    const arr = node.children;
    arr.sort( ( a, b ) => {

      const aIsRel = a.type !== 'group' && a.attribute && a.attribute.type === 'relationship'
      const bIsRel = b.type !== 'group' && b.attribute && b.attribute.type === 'relationship'

      const aIsColl = a.attribute && Util.isLeafCollection( a.attribute.path )
      const bIsColl = b.attribute && Util.isLeafCollection( b.attribute.path )

      if ( aIsColl && !bIsColl ) {
        return 1
      }
      if ( !aIsColl && bIsColl ) {
        return -1
      }
      if ( aIsRel && !bIsRel ) {
        return 1
      }
      if ( !aIsRel && bIsRel ) {
        return -1
      }
      return 0
    } )

    const editors = [];
    for ( let n = 0; n < arr.length; n++ ) {
      if ( Util.isPathValid( arr[n].pathname ) && Util.isLeafCollection( arr[n].pathname ) ) {
        this.createCollectionEditor( device, arr[n], editors, deviceData, cxt, opts );
      } else if ( arr[n].type === 'group' ) {
        this.createGroupEditor( device, arr[n], editors, deviceData, cxt, opts );
      // give each relationship its own container
      } else {
        this.createAttributeViewer( device, arr[n], editors, deviceData, cxt, opts ); 
      }
    }
    const name = StringUtil.camelCaseToTitleCase( node.name, true );
    const { onDelete } = opts

    pEditors.push( (
      <ValueCardGroup
        key={node.pathname}   
        name={name}
        showDelete={showDelete}
        onDelete={() => onDelete( node.pathname, cxt )}
        isRoot={isRoot}>
        {editors}
      </ValueCardGroup> 
    ) )
  }

  createAttributeEditor( device, node, editors, deviceData, cxt = {}, opts = {}, showDelete = false ) {
    const attr = node.attribute
    const ids = Util.getPathIds( attr.path )
    const colls = Util.getPathCollections( attr.path )
    const resPath = Util.getResolvedPath( attr.path, cxt, ids, colls )
    
    const key = `edit-${device.id}-${attr.id}-${resPath}`
    const name = StringUtil.capitalizeAll( node.name )
    // Path.valueAtPath( attr.path, deviceData, undefined )
    const v = deviceData ? Util.getAccessor( attr )( deviceData, undefined, cxt ) : null

    const onSetValue = opts.onSetValue || this.onSetValue
    const { onDelete } = opts
    const liveMsg = opts.liveMsg
    const inputProps = opts.inputProps

    const view = ( 
      <SimAttributeEditor 
        key={key}
        cxt={cxt}
        name={name}
        // is that right?
        value={v}
        simulated={false}
        attribute={attr}
        liveMsg={liveMsg}
        onSetValue={onSetValue}
        onShowFullEditor={() => {}}
        inputProps={inputProps}
        onSetUpdater={() => {}}
        showDelete={showDelete}
        onDelete={() => onDelete( attr.path, cxt )} />
    )
    editors.push( view )
  }

  createAttributeViewer( device, node, editors, deviceData, cxt = {}, opts = {}, showDelete = false ) {
    const attr = node.attribute
    const ids = Util.getPathIds( attr.path )
    const colls = Util.getPathCollections( attr.path )
    const resPath = Util.getResolvedPath( attr.path, cxt, ids, colls )
    
    const key = `view-${device.id}-${attr.id}-${resPath}`
    const name = StringUtil.capitalizeAll( node.name )
    // Path.valueAtPath( attr.path, deviceData, undefined )
    const v = deviceData ? Util.getAccessor( attr )( deviceData, undefined, cxt ) : null

    const onSetValue = opts.onSetValue || this.onSetValue
    const { onDelete } = opts

    const view = ( 
      <SimAttributeView
        cxt={cxt}
        key={key} 
        simulated={isSimulated( device )}
        device={device}
        updaters={this.state.updaters} 
        attribute={attr}
        name={name} 
        value={v} 
        onSetValue={onSetValue}
        onSetUpdater={this.onUpdaterChanged}
        showDelete={showDelete}
        onDelete={() => onDelete( attr.path, cxt )} />
    )
    editors.push( view )
  }
}

function getSimulatorId( device ) {
  const snid = device && device.simNetworkId
  if ( snid ) {
    return device.networkAliases && device.networkAliases[snid] && device.networkAliases[snid].id
  }
  return null
}

function isSimulated( device ) {
  return getSimulatorId( device ) != null
}

// TODO: move to a common place. It is from TimeLabel
function labelFor( time, millis ) {
  // let d = moment.duration( 1000*Math.floor(time/1000))._data
  const d = moment.duration( time )._data
  let l = `${( d.hours > 0 ? `${pad( d.hours )}:` : '' ) + pad( d.minutes )}:${pad( d.seconds )}`
  if ( millis && d.milliseconds > 0 ) {
    const ms = ( d.milliseconds / 1000 ).toFixed( 2 ).toString()
    const index = ms.indexOf( '.' )
    l += `.${ms.substring( index + 1 )}`
  }
  return l
}

function pad( n ) {
  return n < 10 ? `0${n}` : n
}

export default connect(
  state => ( {
    deviceBlueprint : state.deviceBlueprint
  } )
)( SimControlScreen );
